const sizes = {
  small: "S",
  medium: "M",
  large: "L",
  xLargre: "XL",
  xxLargre: "XXL",
  xxxLargre: "XXXL",
  kid2: "2",
  kid3: "3",
  kid4: "4",
  kid5: "5",
};
export default sizes;
